<template>
  <a-card :bordered="false">
    <!-- 表格筛选 start -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSubmit">
        <a-row :gutter="48">
          <!-- 输入关键词查找 -->
          <a-col :md="6" :sm="24">
            <a-form-item>
              <!-- 关键字搜索 -->
              <a-input v-model="queryParam.keyWord" placeholder="请输入关键字">
                <!-- 选择搜索类型 -->
                <a-select slot="addonBefore" v-model="queryParam.keyWordType" placeholder="请选择" style="width:100px">
                  <a-select-option :value="item.id" :key="item.id" v-for="item in keyWordTypeList">{{ item.name }}</a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
          </a-col>
          <!-- 筛选状态查找 -->
          <a-col :md="6" :sm="24">
            <a-form-item title="状态">
              <div style="display: flex;">
                <a-input placeholder="状态" disabled style="width: 80px;text-align: center;"></a-input>
                <a-select v-model="queryParam.status" placeholder="请选择">
                  <a-select-option :value="item.id" :key="item.id" v-for="item in statusList">{{ item.name }}</a-select-option>
                </a-select>
              </div>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
          </template>
          <!-- 展开或者收起筛选项 start -->
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" htmlType="submit">搜索</a-button>
              <a-button style="margin-left: 8px" @click="reset">重置</a-button>
              <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
          <!-- 展开或者收起筛选项 end -->
        </a-row>
      </a-form>
    </div>
    <!-- 表格筛选 end -->
    <!-- 表格内容操作 start -->
    <div class="table-operator">
      <a-button type="primary" @click="clickOrderOutExcel" style="margin-right:15px;">导出</a-button>
    </div>
    <!-- 表格内容操作 end -->
    <!-- 表格 start -->
    <tcg-table
      style="margin-top:20px;"
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      bordered
    >
      <span
        slot="orderId"
        slot-scope="text"
        style="word-break: break-all !important;"
      >
        {{ text }}
      </span>
      <span slot="printId" slot-scope="text">{{ text.start_sc_id }}-{{ text.end_sc_id }}</span>
      <span slot="receiver" slot-scope="text, record">{{ record.receiver + ',' + record.phone + ',' + record.address }}</span>
      <span slot="status" slot-scope="text">{{ text | valInDict(statusList) }}</span>
      <span slot="role" slot-scope="text">{{ text | valInDict(relationTypeDict) }}</span>
      <span slot="action" slot-scope="text, record">
        <template style="margin-right: 8px;">
          <a @click="openViewModal(record.orderId)">查看</a>
        </template>
        <template v-if="record.status === 'NORMAL'">
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" @click="openCancelModal(record.orderId)" href="#">取消订单</a>
          </a-dropdown>
        </template>
        <template v-if="record.status === 'PAY'">
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" @click="openPrintingModal(record.orderId)" href="#">打印云码</a>
          </a-dropdown>
        </template>
        <template v-if="record.status === 'PRINT' || record.status === 'DELIVERED'">
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" @click="openPrintingModal(record.orderId)" href="#">重新打印</a>
          </a-dropdown>
        </template>
        <template v-if="record.status === 'PRINT'">
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" @click="openLogisticsModal(record.orderId, logisticsEdit=false)" href="#">填写单号</a>
          </a-dropdown>
        </template>
        <template v-if="record.status === 'DELIVERED'">
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" @click="openLogisticsModal(record.orderId, logisticsEdit=true)" href="#">修改单号</a>
          </a-dropdown>
        </template>
      </span>
    </tcg-table>
    <!-- 表格 end -->
    <!-- 查看弹出 -->
    <a-drawer
      placement="right"
      width="600"
      :closable="false"
      @close="cancelViewDrawer"
      :visible="viewVisible">
      <!-- 基本信息 -->
      <div>
        <div solt="title">
          <span style="font-size: 18px;font-weight: 700;">基本信息</span>
          <a-button style="float: right" @click="openCancelModal(orderId)" v-if="detail.status === 'NORMAL'">取消订单</a-button>
          <a-button style="float: right" @click="openPrintingModal(orderId)" v-if="detail.status === 'PAY'">打印云码</a-button>
          <div style="float: right;" v-if="detail.status === 'PRINT' ">
            <a-button @click="openPrintingModal(orderId)">重新打印</a-button>
            <a-button style="margin-left: 10px;" @click="openLogisticsModal(detail.orderId, logisticsEdit=false)">填写单号</a-button>
          </div>
          <div style="float: right;" v-if="detail.status === 'DELIVERED' ">
            <a-button @click="openPrintingModal(orderId)">重新打印</a-button>
            <a-button style="margin-left: 10px;" @click="openLogisticsModal(detail.orderId, logisticsEdit=true)">修改单号</a-button>
          </div>
        </div>
        <a-row style="margin-top: 50px;">
          <a-col span="6">订单号：</a-col>
          <a-col>{{ detail.orderId }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">企业简称：</a-col>
          <a-col>{{ detail.tenant_name }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">联系人名称：</a-col>
          <a-col>{{ detail.contacts }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">联系人电话：</a-col>
          <a-col>{{ detail && detail.contact_number }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">状态：</a-col>
          <a-col>{{ detail && detail.status | valInDict(statusList) }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">订单金额：</a-col>
          <a-col>{{ detail && detail.total_price }}元</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">支付方式：</a-col>
          <a-col>{{ detail && detail.pay_type==='WEIXIN'?'微信扫码':detail.pay_type==='ALIPAY'?'支付宝扫码':'' }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">最后更新时间：</a-col>
          <a-col>{{ detail.update_time }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">创建时间：</a-col>
          <a-col>{{ detail && detail.create_time }}</a-col>
        </a-row>

      </div>
      <!-- 订单内容 -->
      <div style="margin-top: 50px;">
        <span style="font-size: 18px;font-weight: 700;">订单内容</span>
        <a-row style="margin-top: 30px;">
          <a-col span="6">打印模板：</a-col>
          <print-mould :mould-data="detail.template"></print-mould>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">类型：</a-col>
          <a-col>{{ detail && detail.order_detail.relation_type === 'PAGE'? '页面' : '商品' }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">页面/商品名称：</a-col>
          <a-col>{{ detail && detail.order_detail.relation_name }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">打印序号：</a-col>
          <a-col>{{ detail && detail.order_detail.start_sc_id + '-' + detail.order_detail.end_sc_id }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">打印数量：</a-col>
          <a-col>{{ detail && detail.order_detail.security_code_count }}张</a-col>
        </a-row>
      </div>
      <!-- 配送信息 -->
      <div style="margin-top: 50px;">
        <span style="font-size: 18px;font-weight: 700;">配送信息</span>
        <a-row style="margin-top: 30px;">
          <a-col span="6">收货地址：</a-col>
          <a-col>{{ detail && detail.receiver + ',' + detail.phone + ',' + detail.address }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">物流公司：</a-col>
          <a-col>{{ detail && detail.express || '无' }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">物流单号：</a-col>
          <a-col>{{ detail && detail.express_number || '无' }}</a-col>
        </a-row>
        <a-row style="margin-top: 30px;">
          <a-col span="6">物流跟踪：</a-col>
          <a-col span="12" v-if="detail&&detail.express_info">
            <a-timeline>
              <a-timeline-item v-for="(item, index) in detail.express_info.list" :key="index"><span class="mr-10">{{ item.time }}</span> {{ item.status }}</a-timeline-item>
            </a-timeline>
          </a-col>
          <a-col v-else>无</a-col>
        </a-row>
      </div>
    </a-drawer>
    <!--取消弹窗-->
    <a-modal
      :visible="cancelModal"
      @cancel="hideCancelModal"
      @ok="handCancelOrder"
      :width="400"
      title="提示"
      cancelText="否"
      okText="是">
      <p>是否确认取消订单?</p>
    </a-modal>
    <!--物流单号弹窗-->
    <a-modal
      :visible="logisticsModal"
      @cancel="cancelLogisticsModal"
      @ok="logisticsSubmit"
      :width="400"
      title="提示"
      cancelText="取消"
      okText="保存">
      <p style="text-align: center;">请选择物流公司并填写物流单号</p>
      <a-form layout="inline">
        <a-form-item :required="true" label="物流公司">
          <a-select
            v-model="logisticsParam.express_code"
            placeholder="请选择"
            style="width:250px"
            onSearch="onSearch"
            showSearch
            optionFilterProp="children">
            <a-select-option :value="item.id" :key="item.id" v-for="item in logisticsList">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :required="true" label="物流单号" style="margin-top: 10px;">
          <a-input placeholder="请输入物流单号" v-model="logisticsParam.express_number" style="width:250px"></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
    <!--物流单号弹窗-->
    <a-modal
      :visible="printingModal"
      @cancel="cancelPrintingModal"
      @ok="printingCode"
      :width="800"
      title="提示"
      cancelText="取消"
      okText="确认打印">
      <p style="text-align: center;">打印前请确认您已经安装打印驱动，未安装请<a href="https://8899-city.oss-cn-shenzhen.aliyuncs.com/soft/%E6%89%93%E5%8D%B0%E6%9C%BA%E5%AE%89%E8%A3%85%E5%8C%85.zip">点击此处</a>安装</p>
      <a-row style="margin-top: 30px;">
        <a-col span="6">订单号：</a-col>
        <a-col>{{ detail && detail.orderId }}</a-col>
      </a-row>
      <a-row style="margin-top: 30px;">
        <a-col span="6">订单状态：</a-col>
        <a-col>{{ detail && detail.status | valInDict(statusList) }}</a-col>
      </a-row>
      <a-row style="margin-top: 30px;">
        <a-col span="6">类型：</a-col>
        <a-col>{{ detail && detail.order_detail.relation_type === 'PAGE'? '页面' : '商品' }}</a-col>
      </a-row>
      <a-row style="margin-top: 30px;">
        <a-col span="6">页面/商品名称：</a-col>
        <a-col>{{ detail && detail.order_detail.relation_name }}</a-col>
      </a-row>
      <a-row style="margin-top: 30px;">
        <a-col span="6">打印数量：</a-col>
        <a-col>{{ detail && detail.order_detail.security_code_count }}张</a-col>
      </a-row>
      <a-row style="margin-top: 30px;">
        <a-col span="6">打印序号：</a-col>
        <a-col v-if=" detail ">{{ detail.order_detail.start_sc_id + '-' + detail.order_detail.end_sc_id }}</a-col>
      </a-row>
      <a-row style="margin-top: 30px;">
        <a-col span="6">打印模板：</a-col>
        <print-mould :mould-data="detail.template"></print-mould>
      </a-row>
    </a-modal>
    <!-- 打印服务 -->
    <print-service
      @close="closePrint"
      ref="PrintService"
      :print-data="printData"
    />
  </a-card>
</template>
<script>

import PrintService from '@/components/PrintService'
import PrintMould from '@/components/PrintMould'
import { getPrintList, getPrintDetail, cancelOrder, orderPre, addExpress, printIndex } from '@/api/order'
import { TcgTable } from '@/components'
import code from './operation/codeTemplate'
import _ from 'lodash'
const logisticsList = [
  {
    id: 'sf',
    express: '顺丰'
  },
  {
    id: 'yd',
    express: '韵达'
  }
]
export default {
  components: {
    TcgTable,
    code,
    PrintService,
    PrintMould
    // viewDrawer,
    // addDrawer,
    // rolePermission
  },
  data () {
    return {
      multiple: 5, // px与mm转化倍数，统一为5，勿修改
      // 打印弹窗开关
      printingModal: false,
      // 取消订单弹窗开关
      cancelModal: false,
      // 物流单号弹窗开关
      logisticsModal: false,
      // 添加抽屉状态开关
      addDrawerVisible: false,
      // 编辑抽屉状态开关
      editDrawerVisible: false,
      // 设置权限抽屉开关
      rolePermissionVisible: false,
      // 关键字搜索类型列表
      keyWordTypeList: '',
      // 状态字典
      statusList: '',
      // 页面/商品
      relationTypeDict: '',
      // 物流公司字典
      logisticsList,
      // 字典
      dict: {
        statusDict: [],
        roleDict: []
      },
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        // page: 1,
        // size: 15,
        status: '',
        keyWordType: 'orderId',
        keyWord: ''
      },
      // 物流信息参数
      logisticsParam: {
        express_code: 'ANXL',
        orderId: '',
        express: '',
        express_number: ''
      },
      // 表头
      columns: [
        {
          title: '订单号',
          dataIndex: 'orderId',
          scopedSlots: { customRender: 'orderId' }
        },
        // {
        //   title: '打印模板',
        //   dataIndex: 'order_detail.template_name',
        //   width: 'auto'
        // },
        {
          title: '打印数量',
          dataIndex: 'order_detail.security_code_count',
          width: 'auto'
        },
        // {
        //   title: '打印序号',
        //   dataIndex: 'order_detail',
        //   width: 'auto',
        //   scopedSlots: { customRender: 'printId' }
        // },
        {
          title: '类型',
          dataIndex: 'order_detail.relation_type',
          width: 'auto',
          scopedSlots: { customRender: 'role' }
        },
        {
          title: '页面/商品名称',
          dataIndex: 'order_detail.relation_name',
          width: 'auto'
        },
        {
          title: '收货地址',
          dataIndex: 'receiver',
          width: '200px',
          scopedSlots: { customRender: 'receiver' }
        },
        {
          title: '企业简称',
          dataIndex: 'tenant_name',
          width: 'auto'
        },
        {
          title: '联系人名称',
          dataIndex: 'contacts',
          width: 'auto'
        },
        {
          title: '联系人电话',
          dataIndex: 'contact_number',
          width: 'auto'
        },
        {
          title: '业务经理',
          dataIndex: 'business_manager',
          width: 'auto'
        },
        {
          title: '支付金额',
          dataIndex: 'payment_amount',
          width: 'auto'
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: '80px',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '最后更新时间',
          dataIndex: 'update_time',
          width: 'auto'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: 'auto',
          scopedSlots: { customRender: 'time' }
        },
        {
          title: '操作',
          dataIndex: 'id',
          width: '150px',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getPrintList(Object.assign(parameter, this.queryParam)).then(res => {
          return res
        })
      },
      viewVisible: false,
      orderId: '',
      detail: '',
      defalutPermissionArr: [],
      codeTypeDict: '',
      logisticsEdit: false,
      printData: {}
    }
  },
  created () {
    this.handelPre()
  },
  methods: {
    handelPre () {
      orderPre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.statusList = _.get(res, 'data.printOrderStatusDict', [])
          this.keyWordTypeList = _.get(res, 'data.printOrderkeyWordTypeDict', [])
          this.relationTypeDict = _.get(res, 'data.relationTypeDict', [])
          this.codeTypeDict = _.get(res, 'data.codeTypeDict', [])
          this.logisticsList = _.get(res, 'data.expressDict', [])
          const all = {
            id: '',
            name: '全部'
          }
          this.statusList.unshift(all)
        }
      })
    },
    // 重置按钮
    reset () {
      this.queryParam = {
        status: '',
        keyWordType: 'orderId',
        keyWord: '',
        type: 'all'
      }
    },
    getDetail () {
      const params = {
        orderId: this.orderId
      }
      getPrintDetail(params).then(res => {
        if (_.get(res, 'code') === 200) {
          this.detail = _.get(res, 'data', [])
          this.detail.template.unit.orderId = this.detail.orderId
          if (this.logisticsEdit === true) {
            this.logisticsParam.express_code = this.detail.express_code
            this.logisticsParam.express = this.detail.express
            this.logisticsParam.express_number = this.detail.express_number
          } else {
            this.logisticsParam.express_code = 'ANXL'
            this.logisticsParam.express = ''
            this.logisticsParam.express_number = ''
          }
        }
      })
    },
    // 关闭查看按钮事件
    cancelViewDrawer () {
      this.viewVisible = false
    },
    // 打开查看抽屉
    openViewModal (id) {
      this.orderId = id
      this.viewVisible = true
      this.getDetail()
    },
    // 在查看抽屉中完成编辑
    finishViewAndEdit () {
      this.$refs.table.refresh(true)
    },
    // 完成创建
    finish () {
      this.handelAddDrawer()
      this.$refs.table.refresh(true)
    },
    // 打开添加用户抽屉
    openAddDrawer () {
      this.addDrawerVisible = true
    },
    // 关闭添加用户抽屉
    handelAddDrawer () {
      this.addDrawerVisible = false
    },
    // 打开权限设置抽屉
    openRolePermission (record) {
      this.role_id = record.role_id
      this.defalutPermissionArr = record.role_auth.split(',')
      for (const i in this.defalutPermissionArr) {
        this.defalutPermissionArr[i] = parseInt(this.defalutPermissionArr[i])
      }
      this.rolePermissionVisible = true
    },
    // 关闭权限设置抽屉
    handelRolePermission () {
      this.rolePermissionVisible = false
      this.$refs.table.refresh(true)
    },
    // 打开编辑抽屉
    openEditDrawer (id) {
      this.userId = id
      this.editDrawerVisible = true
    },
    // 关闭编辑抽屉
    handelEditDrawer () {
      this.editDrawerVisible = false
    },
    // 打开取消订单弹窗
    openCancelModal (id) {
      this.orderId = id
      this.cancelModal = true
    },
    // 取消订单
    cancelOrder () {
      // this.orderId = id
      this.cancelModal = false
      this.handCancelOrder()
    },
    // 关闭取消订单弹窗
    hideCancelModal () {
      this.cancelModal = false
    },
    // 打开物流弹窗
    openLogisticsModal (orderId, logisticsEdit) {
      this.logisticsEdit = logisticsEdit
      this.logisticsModal = true
      this.orderId = orderId
      this.getDetail()
      if (orderId) {
        this.logisticsParam.orderId = orderId
      } else {
        this.logisticsParam.orderId = this.detail.orderId
      }
    },
    // 关闭物流弹窗
    cancelLogisticsModal () {
      this.logisticsModal = false
    },
    // 打开打印弹窗
    openPrintingModal (id) {
      this.orderId = id
      this.printingModal = true
      this.getDetail()
      // const params = {
      //   orderId: id
      // }
      // printIndex(params).then(res => {
      //   if (_.get(res, 'code') === 200) {
      //     console.log(res)
      //     this.printData = res.data
      //   }
      // })
    },
    // 关闭打印弹窗
    cancelPrintingModal () {
      this.printingModal = false
    },
    // 取消订单
    handCancelOrder () {
      const parameter = {
        order_type: 'PRINT',
        orderId: this.orderId
      }
      cancelOrder(parameter).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('取消成功')
          this.cancelModal = false
          this.$refs.table.refresh(true)
        }
      })
    },
    // 物流单号提交
    logisticsSubmit () {
      const express = this.logisticsList.find(item => {
        return item.id === this.logisticsParam.express_code
      })
      this.logisticsParam.express = express.name
      if (this.logisticsParam.orderId === undefined) {
        return
      }
      if (this.logisticsParam.express === '' || this.logisticsParam.express_number === '') {
        this.$message.error('请完善填写信息')
        return
      }
      const params = this.logisticsParam
      addExpress(params).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('填写成功')
          this.$refs.table.refresh(true)
          this.logisticsModal = false
        } else {
          this.$message.error(res.message)
          this.logisticsModal = false
        }
      })
    },
    // 导出功能
    clickOrderOutExcel () {
      setTimeout(function() {
        window.location.href = window.location.origin + '/admin.php/order/orderOutExcel?order_type=PRINT'
      }, 1000)
    },
    // 打印云码
    printingCode() {
      this.getPrintIndex()
      // const printHtml = document.getElementById('printContent').innerHTML // 需要打印的内容
      // const newWin = window.open('', '_blank')
      // newWin.document.write(
      //   '<html><head><title>打印模板</title><style>*{margin:0;padding:0}.comp {position: absolute;overflow: hidden;z-index: 1;user-select: none;}</style></head><body>'
      // )
      // newWin.document.write(printHtml)
      // newWin.document.write('</body></html>')
      // newWin.print()
      // newWin.close() // 打印完成后关闭
    },
    getPrintIndex () {
      const params = {
        orderId: this.orderId
      }
      printIndex(params).then(res => {
        if (_.get(res, 'code') === 200) {
          this.printData = res.data
          this.$refs.PrintService.showModal()
        }
      })
    },
    closePrint () {
      this.$refs.table.refresh(true)
    },
    onSearch (val) {
      console.log(val)
    },
    // 提交筛选
    handleSubmit (e) {
      e.preventDefault()
      this.$refs.table.refresh(true)
    }
  }
}
</script>
<style lang="less" scoped>
</style>
